const ar = {
  nav: {
    home: "\u0627\u0644\u0631\u0626\u064a\u0633\u064a\u0629",
    browse: "\u062a\u0635\u0641\u062d \u062d\u0641\u0644\u0627\u062a \u0627\u0644\u0632\u0641\u0627\u0641",
    browseWeddings: "\u062a\u0635\u0641\u062d \u062d\u0641\u0644\u0627\u062a \u0627\u0644\u0632\u0641\u0627\u0641",
    dashboard: "\u0644\u0648\u062d\u0629 \u0627\u0644\u062a\u062d\u0643\u0645",
    messages: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644",
    profile: "\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062e\u0635\u064a",
    login: "\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644",
    register: "\u0627\u0644\u062a\u0633\u062c\u064a\u0644",
    logout: "\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062e\u0631\u0648\u062c",
    admin: "\u0627\u0644\u0625\u062f\u0627\u0631\u0629",
  },
  landing: {
    hero: {
      badge: "\u0645\u0646\u0635\u0629 \u062a\u062c\u0627\u0631\u0628 \u0627\u0644\u0632\u0641\u0627\u0641 \u0631\u0642\u0645 1",
      title: "\u0639\u0634 \u062d\u0641\u0644\u0627\u062a \u0632\u0641\u0627\u0641 \u0644\u0627 \u062a\u064f\u0646\u0633\u0649 \u062d\u0648\u0644 \u0627\u0644\u0639\u0627\u0644\u0645",
      subtitle: "WEDVAYA \u064a\u0631\u0628\u0637 \u0627\u0644\u0623\u0632\u0648\u0627\u062c \u0628\u0627\u0644\u0645\u0633\u0627\u0641\u0631\u064a\u0646 \u0627\u0644\u0628\u0627\u062d\u062b\u064a\u0646 \u0639\u0646 \u062a\u062c\u0627\u0631\u0628 \u062b\u0642\u0627\u0641\u064a\u0629 \u0623\u0635\u064a\u0644\u0629. \u0643\u0646 \u062c\u0632\u0621\u0627\u064b \u0645\u0646 \u0644\u062d\u0638\u0629 \u0645\u0645\u064a\u0632\u0629 \u2013 \u0643\u0645\u0636\u064a\u0641 \u0623\u0648 \u0643\u0636\u064a\u0641.",
      cta_host: "\u0627\u0628\u062f\u0623 \u0643\u0645\u0636\u064a\u0641",
      cta_guest: "\u0627\u0643\u062a\u0634\u0641 \u062d\u0641\u0644\u0627\u062a \u0627\u0644\u0632\u0641\u0627\u0641",
    },
    trust: {
      freeRegistration: "\u062a\u0633\u062c\u064a\u0644 \u0645\u062c\u0627\u0646\u064a",
      securePayment: "\u062f\u0641\u0639 \u0622\u0645\u0646",
      gdprCompliant: "\u0645\u062a\u0648\u0627\u0641\u0642 \u0645\u0639 GDPR",
    },
    stats: {
      weddings: "\u062d\u0641\u0644\u0627\u062a \u0632\u0641\u0627\u0641",
      worldwide: "\u062d\u0648\u0644 \u0627\u0644\u0639\u0627\u0644\u0645",
      guests: "\u0636\u064a\u0648\u0641",
      matched: "\u062a\u0645 \u0627\u0644\u0631\u0628\u0637",
      countries: "\u062f\u0648\u0644",
      represented: "\u0645\u0645\u062b\u0644\u0629",
      rating: "\u062a\u0642\u064a\u064a\u0645",
      average: "\u0645\u062a\u0648\u0633\u0637",
    },
    features: {
      title: "\u0644\u0645\u0627\u0630\u0627 WEDVAYA\u061f",
      subtitle: "\u0646\u062c\u0639\u0644 \u0645\u0634\u0627\u0631\u0643\u0629 \u062a\u062c\u0627\u0631\u0628 \u0627\u0644\u0632\u0641\u0627\u0641 \u0627\u0644\u0644\u0627 \u062a\u064f\u0646\u0633\u0649 \u0633\u0647\u0644\u0629 \u0648\u0622\u0645\u0646\u0629.",
      secure: {
        title: "\u0645\u062f\u0641\u0648\u0639\u0627\u062a \u0622\u0645\u0646\u0629",
        desc: "\u062c\u0645\u064a\u0639 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062a \u0645\u062d\u0645\u064a\u0629 \u0628\u0648\u0627\u0633\u0637\u0629 Stripe. \u0623\u0645\u0648\u0627\u0644\u0643 \u0622\u0645\u0646\u0629 \u062d\u062a\u0649 \u064a\u062a\u0645 \u0627\u0644\u062d\u062f\u062b.",
      },
      verified: {
        title: "\u0645\u0644\u0641\u0627\u062a \u0645\u0648\u062b\u0642\u0629",
        desc: "\u062a\u062d\u0642\u0642 \u0627\u062e\u062a\u064a\u0627\u0631\u064a \u0645\u0646 \u0627\u0644\u0647\u0648\u064a\u0629 \u0644\u0645\u0632\u064a\u062f \u0645\u0646 \u0627\u0644\u062b\u0642\u0629 \u0628\u064a\u0646 \u0627\u0644\u0645\u0636\u064a\u0641\u064a\u0646 \u0648\u0627\u0644\u0636\u064a\u0648\u0641.",
      },
      global: {
        title: "\u0623\u062d\u062f\u0627\u062b \u0639\u0627\u0644\u0645\u064a\u0629",
        desc: "\u0645\u0646 \u062d\u0641\u0644\u0627\u062a \u0627\u0644\u0632\u0641\u0627\u0641 \u0627\u0644\u0631\u0648\u0645\u0627\u0646\u0633\u064a\u0629 \u0641\u064a \u062a\u0648\u0633\u0643\u0627\u0646\u0627 \u0625\u0644\u0649 \u0627\u0644\u0627\u062d\u062a\u0641\u0627\u0644\u0627\u062a \u0627\u0644\u062a\u0642\u0644\u064a\u062f\u064a\u0629 \u0641\u064a \u0627\u0644\u0647\u0646\u062f.",
      },
      contact: {
        title: "\u062a\u0648\u0627\u0635\u0644 \u0645\u0628\u0627\u0634\u0631",
        desc: "\u0628\u0639\u062f \u0627\u0644\u062d\u062c\u0632\u060c \u064a\u0645\u0643\u0646\u0643 \u0627\u0644\u062a\u0648\u0627\u0635\u0644 \u0645\u0628\u0627\u0634\u0631\u0629 \u0645\u0639 \u0627\u0644\u0645\u0636\u064a\u0641.",
      },
      gdpr: {
        title: "\u0645\u062a\u0648\u0627\u0641\u0642 \u0645\u0639 GDPR",
        desc: "\u0628\u064a\u0627\u0646\u0627\u062a\u0643 \u0622\u0645\u0646\u0629. \u0646\u0644\u062a\u0632\u0645 \u0628\u0635\u0631\u0627\u0645\u0629 \u0628\u0625\u0631\u0634\u0627\u062f\u0627\u062a \u062d\u0645\u0627\u064a\u0629 \u0627\u0644\u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u0623\u0648\u0631\u0648\u0628\u064a\u0629.",
      },
      instant: {
        title: "\u062d\u062c\u0632 \u0641\u0648\u0631\u064a",
        desc: "\u0639\u0645\u0644\u064a\u0629 \u062a\u0642\u062f\u064a\u0645 \u0633\u0631\u064a\u0639\u0629. \u0633\u062a\u062a\u0644\u0642\u0649 \u0631\u062f\u0627\u064b \u062e\u0644\u0627\u0644 48 \u0633\u0627\u0639\u0629.",
      },
    },
    howItWorks: {
      title: "\u0643\u064a\u0641 \u064a\u0639\u0645\u0644",
      subtitle: "\u0628\u0636\u0639 \u062e\u0637\u0648\u0627\u062a \u0641\u0642\u0637 \u0644\u062a\u062c\u0631\u0628\u062a\u0643 \u0627\u0644\u0644\u0627 \u062a\u064f\u0646\u0633\u0649",
      step1: {
        title: "\u0627\u0628\u062d\u062b \u0639\u0646 \u062d\u0641\u0644 \u0632\u0641\u0627\u0641",
        desc: "\u062a\u0635\u0641\u062d \u0645\u062c\u0645\u0648\u0639\u062a\u0646\u0627 \u0645\u0646 \u062d\u0641\u0644\u0627\u062a \u0627\u0644\u0632\u0641\u0627\u0641 \u0627\u0644\u0641\u0631\u064a\u062f\u0629 \u062d\u0648\u0644 \u0627\u0644\u0639\u0627\u0644\u0645.",
      },
      step2: {
        title: "\u0623\u0631\u0633\u0644 \u0637\u0644\u0628\u0627\u064b",
        desc: "\u0639\u0631\u0651\u0641 \u0646\u0641\u0633\u0643 \u0644\u0644\u0632\u0648\u062c\u064a\u0646 \u0648\u0623\u062e\u0628\u0631\u0647\u0645 \u0644\u0645\u0627\u0630\u0627 \u062a\u0631\u064a\u062f \u0627\u0644\u062d\u0636\u0648\u0631.",
      },
      step3: {
        title: "\u0627\u0644\u062a\u0623\u0643\u064a\u062f \u0648\u0627\u0644\u062f\u0641\u0639",
        desc: "\u0628\u0639\u062f \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629\u060c \u0627\u062f\u0641\u0639 \u0628\u0623\u0645\u0627\u0646 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062a\u0631\u0646\u062a. \u0639\u0646\u062f\u0647\u0627 \u0641\u0642\u0637 \u064a\u062a\u0645 \u062d\u062c\u0632 \u0645\u0643\u0627\u0646\u0643.",
      },
      step4: {
        title: "\u0627\u062d\u062a\u0641\u0644",
        desc: "\u0639\u0634 \u062d\u0641\u0644 \u0632\u0641\u0627\u0641 \u0623\u0635\u064a\u0644 \u0648\u0627\u0635\u0646\u0639 \u0630\u0643\u0631\u064a\u0627\u062a \u062a\u062f\u0648\u0645 \u0645\u062f\u0649 \u0627\u0644\u062d\u064a\u0627\u0629.",
      },
    },
    howItWorksHost: {
      step1: {
        title: "\u0623\u0636\u0641 \u062d\u0641\u0644 \u0632\u0641\u0627\u0641\u0643",
        desc: "\u0623\u0646\u0634\u0626 \u0645\u0644\u0641\u0627\u064b \u0634\u062e\u0635\u064a\u0627\u064b \u0644\u062d\u0641\u0644 \u0632\u0641\u0627\u0641\u0643 \u0645\u0639 \u062c\u0645\u064a\u0639 \u0627\u0644\u062a\u0641\u0627\u0635\u064a\u0644 \u0627\u0644\u0645\u0647\u0645\u0629.",
      },
      step2: {
        title: "\u0631\u0627\u062c\u0639 \u0627\u0644\u0637\u0644\u0628\u0627\u062a",
        desc: "\u0627\u0637\u0644\u0639 \u0639\u0644\u0649 \u0645\u0644\u0641\u0627\u062a \u0627\u0644\u0636\u064a\u0648\u0641 \u0627\u0644\u0645\u0647\u062a\u0645\u064a\u0646.",
      },
      step3: {
        title: "\u0627\u062d\u0635\u0644 \u0639\u0644\u0649 \u0623\u0645\u0648\u0627\u0644\u0643",
        desc: "\u0628\u0639\u062f \u0627\u0644\u062d\u062f\u062b\u060c \u062a\u062d\u0635\u0644 \u062a\u0644\u0642\u0627\u0626\u064a\u0627\u064b \u0639\u0644\u0649 85% \u0645\u0646 \u0627\u0644\u0625\u064a\u0631\u0627\u062f\u0627\u062a.",
      },
      step4: {
        title: "\u0627\u062d\u062a\u0641\u0644 \u0645\u0639\u0627\u064b",
        desc: "\u0634\u0627\u0631\u0643 \u064a\u0648\u0645\u0643 \u0627\u0644\u0645\u0645\u064a\u0632 \u0645\u0639 \u0623\u0634\u062e\u0627\u0635 \u0645\u0646 \u062c\u0645\u064a\u0639 \u0623\u0646\u062d\u0627\u0621 \u0627\u0644\u0639\u0627\u0644\u0645.",
      },
    },
    tabs: {
      forGuests: "\u0644\u0644\u0636\u064a\u0648\u0641",
      forHosts: "\u0644\u0644\u0645\u0636\u064a\u0641\u064a\u0646",
    },
    testimonials: {
      title: "\u0645\u0627\u0630\u0627 \u064a\u0642\u0648\u0644 \u0645\u062c\u062a\u0645\u0639\u0646\u0627",
      subtitle: "\u062a\u062c\u0627\u0631\u0628 \u062d\u0642\u064a\u0642\u064a\u0629 \u0645\u0646 \u0623\u0634\u062e\u0627\u0635 \u062d\u0642\u064a\u0642\u064a\u064a\u0646",
    },
    featured: {
      title: "\u062d\u0641\u0644\u0627\u062a \u0632\u0641\u0627\u0641 \u0645\u0645\u064a\u0632\u0629",
      subtitle: "\u0627\u0643\u062a\u0634\u0641 \u0627\u062d\u062a\u0641\u0627\u0644\u0627\u062a \u0641\u0631\u064a\u062f\u0629 \u062d\u0648\u0644 \u0627\u0644\u0639\u0627\u0644\u0645",
      viewAll: "\u0639\u0631\u0636 \u0627\u0644\u0643\u0644",
      perPerson: "\u0644\u0644\u0634\u062e\u0635",
    },
    cta: {
      title: "\u0645\u0633\u062a\u0639\u062f \u0644\u062a\u062c\u0631\u0628\u062a\u0643 \u0627\u0644\u0644\u0627 \u062a\u064f\u0646\u0633\u0649\u061f",
      subtitle: "\u0627\u0646\u0636\u0645 \u0625\u0644\u0649 \u0645\u062c\u062a\u0645\u0639 WEDVAYA",
      description: "\u0633\u0648\u0627\u0621 \u0643\u0646\u062a \u062a\u0631\u064a\u062f \u0645\u0634\u0627\u0631\u0643\u0629 \u0632\u0641\u0627\u0641\u0643 \u0645\u0639 \u0627\u0644\u0639\u0627\u0644\u0645 \u0623\u0648 \u062a\u0628\u062d\u062b \u0639\u0646 \u062a\u062c\u0631\u0628\u0629 \u0633\u0641\u0631 \u0641\u0631\u064a\u062f\u0629 \u2013 WEDVAYA \u064a\u062c\u0639\u0644 \u0630\u0644\u0643 \u0645\u0645\u0643\u0646\u0627\u064b.",
      button: "\u0627\u0628\u062f\u0623 \u0645\u062c\u0627\u0646\u0627\u064b",
      becomeHost: "\u0643\u0646 \u0645\u0636\u064a\u0641\u0627\u064b \u0627\u0644\u0622\u0646",
      learnMore: "\u0627\u0639\u0631\u0641 \u0627\u0644\u0645\u0632\u064a\u062f",
    },
    press: {
      title: "\u0643\u0645\u0627 \u0634\u0648\u0647\u062f \u0641\u064a",
    },
  },
  auth: {
    login: {
      title: "\u0645\u0631\u062d\u0628\u0627\u064b \u0628\u0639\u0648\u062f\u062a\u0643",
      email: "\u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a",
      password: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      button: "\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644",
      noAccount: "\u0644\u064a\u0633 \u0644\u062f\u064a\u0643 \u062d\u0633\u0627\u0628\u061f",
      register: "\u0633\u062c\u0644 \u0627\u0644\u0622\u0646",
      forgotPassword: "\u0646\u0633\u064a\u062a \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631\u061f",
    },
    register: {
      title: "\u0625\u0646\u0634\u0627\u0621 \u062d\u0633\u0627\u0628",
      name: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0643\u0627\u0645\u0644",
      email: "\u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a",
      password: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      role: "\u0623\u0631\u064a\u062f...",
      roleHost: "\u0627\u0633\u062a\u0636\u0627\u0641\u0629 \u062d\u0641\u0644 \u0632\u0641\u0627\u0641",
      roleGuest: "\u062d\u0636\u0648\u0631 \u062d\u0641\u0644\u0627\u062a \u0627\u0644\u0632\u0641\u0627\u0641",
      terms: "\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0627\u0644\u0634\u0631\u0648\u0637 \u0648\u0633\u064a\u0627\u0633\u0629 \u0627\u0644\u062e\u0635\u0648\u0635\u064a\u0629",
      button: "\u062a\u0633\u062c\u064a\u0644",
      hasAccount: "\u0644\u062f\u064a\u0643 \u062d\u0633\u0627\u0628 \u0628\u0627\u0644\u0641\u0639\u0644\u061f",
      login: "\u0633\u062c\u0644 \u062f\u062e\u0648\u0644\u0643",
    },
    forgotPassword: {
      title: "\u0646\u0633\u064a\u062a \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631\u061f",
      description: "\u0623\u062f\u062e\u0644 \u0628\u0631\u064a\u062f\u0643 \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u0648\u0633\u0646\u0631\u0633\u0644 \u0644\u0643 \u0631\u0627\u0628\u0637 \u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u062a\u0639\u064a\u064a\u0646",
      submit: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0627\u0628\u0637",
      sent: "\u062a\u062d\u0642\u0642 \u0645\u0646 \u0628\u0631\u064a\u062f\u0643",
      sentDescription: "\u0625\u0630\u0627 \u0643\u0627\u0646 \u0647\u0646\u0627\u0643 \u062d\u0633\u0627\u0628 \u0628\u0647\u0630\u0627 \u0627\u0644\u0628\u0631\u064a\u062f\u060c \u0633\u062a\u062a\u0644\u0642\u0649 \u0631\u0627\u0628\u0637 \u0625\u0639\u0627\u062f\u0629 \u062a\u0639\u064a\u064a\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631.",
      backToLogin: "\u0627\u0644\u0639\u0648\u062f\u0629 \u0644\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644",
    },
    resetPassword: {
      title: "\u0625\u0639\u0627\u062f\u0629 \u062a\u0639\u064a\u064a\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      description: "\u0623\u062f\u062e\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062c\u062f\u064a\u062f\u0629",
      newPassword: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062c\u062f\u064a\u062f\u0629",
      confirmPassword: "\u062a\u0623\u0643\u064a\u062f \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      submit: "\u0625\u0639\u0627\u062f\u0629 \u062a\u0639\u064a\u064a\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      success: "\u062a\u0645 \u0625\u0639\u0627\u062f\u0629 \u062a\u0639\u064a\u064a\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631!",
      successDesc: "\u062a\u0645 \u0625\u0639\u0627\u062f\u0629 \u062a\u0639\u064a\u064a\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0628\u0646\u062c\u0627\u062d. \u064a\u0645\u0643\u0646\u0643 \u0627\u0644\u0622\u0646 \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644.",
      goToLogin: "\u0627\u0644\u0630\u0647\u0627\u0628 \u0644\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644",
      mismatch: "\u0643\u0644\u0645\u0627\u062a \u0627\u0644\u0645\u0631\u0648\u0631 \u063a\u064a\u0631 \u0645\u062a\u0637\u0627\u0628\u0642\u0629",
      tooShort: "\u064a\u062c\u0628 \u0623\u0646 \u062a\u0643\u0648\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 6 \u0623\u062d\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
    },
    verification: {
      verifying: "\u062c\u0627\u0631\u064a \u0627\u0644\u062a\u062d\u0642\u0642 \u0645\u0646 \u0628\u0631\u064a\u062f\u0643...",
      pleaseWait: "\u064a\u0631\u062c\u0649 \u0627\u0644\u0627\u0646\u062a\u0638\u0627\u0631",
      successTitle: "\u062a\u0645 \u0627\u0644\u062a\u062d\u0642\u0642 \u0645\u0646 \u0627\u0644\u0628\u0631\u064a\u062f!",
      success: "\u062a\u0645 \u0627\u0644\u062a\u062d\u0642\u0642 \u0645\u0646 \u0628\u0631\u064a\u062f\u0643 \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u0628\u0646\u062c\u0627\u062d!",
      errorTitle: "\u0641\u0634\u0644 \u0627\u0644\u062a\u062d\u0642\u0642",
      noToken: "\u0644\u0645 \u064a\u062a\u0645 \u062a\u0648\u0641\u064a\u0631 \u0631\u0645\u0632 \u0627\u0644\u062a\u062d\u0642\u0642",
      goToLogin: "\u0627\u0644\u0630\u0647\u0627\u0628 \u0644\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644",
      tryAgain: "\u0627\u0644\u062a\u0633\u062c\u064a\u0644 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649",
    },
  },
  dashboard: {
    host: {
      title: "\u0644\u0648\u062d\u0629 \u062a\u062d\u0643\u0645 \u0627\u0644\u0645\u0636\u064a\u0641",
      myWeddings: "\u062d\u0641\u0644\u0627\u062a \u0632\u0641\u0627\u0641\u064a",
      applications: "\u0627\u0644\u0637\u0644\u0628\u0627\u062a",
      earnings: "\u0627\u0644\u0623\u0631\u0628\u0627\u062d",
      messages: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644",
      createWedding: "\u0625\u0646\u0634\u0627\u0621 \u062d\u0641\u0644 \u0632\u0641\u0627\u0641",
      noWeddings: "\u0644\u0645 \u064a\u062a\u0645 \u0625\u0646\u0634\u0627\u0621 \u062d\u0641\u0644\u0627\u062a \u0632\u0641\u0627\u0641 \u0628\u0639\u062f",
    },
    guest: {
      title: "\u0644\u0648\u062d\u0629 \u062a\u062d\u0643\u0645 \u0627\u0644\u0636\u064a\u0641",
      myApplications: "\u0637\u0644\u0628\u0627\u062a\u064a",
      browseWeddings: "\u062a\u0635\u0641\u062d \u062d\u0641\u0644\u0627\u062a \u0627\u0644\u0632\u0641\u0627\u0641",
      messages: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644",
      profile: "\u0645\u0644\u0641\u064a \u0627\u0644\u0634\u062e\u0635\u064a",
    },
  },
  wedding: {
    search: {
      title: "\u0627\u0628\u062d\u062b \u0639\u0646 \u062d\u0641\u0644\u0627\u062a \u0627\u0644\u0632\u0641\u0627\u0641",
      location: "\u0627\u0644\u0645\u0648\u0642\u0639",
      date: "\u0627\u0644\u062a\u0627\u0631\u064a\u062e",
      price: "\u0627\u0644\u0633\u0639\u0631",
      search: "\u0628\u062d\u062b",
      reset: "\u0625\u0639\u0627\u062f\u0629 \u062a\u0639\u064a\u064a\u0646",
      noResults: "\u0644\u0645 \u064a\u062a\u0645 \u0627\u0644\u0639\u062b\u0648\u0631 \u0639\u0644\u0649 \u062d\u0641\u0644\u0627\u062a \u0632\u0641\u0627\u0641",
    },
    card: {
      slots: "\u0623\u0645\u0627\u0643\u0646 \u0645\u062a\u0627\u062d\u0629",
      perGuest: "\u0644\u0643\u0644 \u0636\u064a\u0641",
      apply: "\u062a\u0642\u062f\u0645",
      viewDetails: "\u0639\u0631\u0636 \u0627\u0644\u062a\u0641\u0627\u0635\u064a\u0644",
    },
    detail: {
      about: "\u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0632\u0641\u0627\u0641",
      host: "\u0627\u0644\u0645\u0636\u064a\u0641",
      location: "\u0627\u0644\u0645\u0648\u0642\u0639",
      date: "\u0627\u0644\u062a\u0627\u0631\u064a\u062e",
      dresscode: "\u0642\u0648\u0627\u0639\u062f \u0627\u0644\u0644\u0628\u0627\u0633",
      price: "\u0627\u0644\u0633\u0639\u0631 \u0644\u0643\u0644 \u0636\u064a\u0641",
      slots: "\u0627\u0644\u0623\u0645\u0627\u0643\u0646 \u0627\u0644\u0645\u062a\u0627\u062d\u0629",
      apply: "\u062a\u0642\u062f\u0645 \u0627\u0644\u0622\u0646",
      alreadyApplied: "\u062a\u0645 \u0627\u0644\u062a\u0642\u062f\u064a\u0645 \u0628\u0627\u0644\u0641\u0639\u0644",
    },
    create: {
      title: "\u0625\u0646\u0634\u0627\u0621 \u062d\u0641\u0644 \u0632\u0641\u0627\u0641 \u062c\u062f\u064a\u062f",
      titleField: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
      description: "\u0627\u0644\u0648\u0635\u0641",
      location: "\u0627\u0644\u0645\u0648\u0642\u0639",
      country: "\u0627\u0644\u0628\u0644\u062f",
      date: "\u0627\u0644\u062a\u0627\u0631\u064a\u062e",
      dresscode: "\u0642\u0648\u0627\u0639\u062f \u0627\u0644\u0644\u0628\u0627\u0633",
      price: "\u0627\u0644\u0633\u0639\u0631 \u0644\u0643\u0644 \u0636\u064a\u0641",
      slots: "\u0639\u062f\u062f \u0627\u0644\u0636\u064a\u0648\u0641",
      currency: "\u0627\u0644\u0639\u0645\u0644\u0629",
      submit: "\u0625\u0646\u0634\u0627\u0621 \u062d\u0641\u0644 \u0627\u0644\u0632\u0641\u0627\u0641",
    },
  },
  application: {
    status: {
      pending: "\u0642\u064a\u062f \u0627\u0644\u0627\u0646\u062a\u0638\u0627\u0631",
      approved: "\u0645\u0648\u0627\u0641\u0642 \u0639\u0644\u064a\u0647",
      rejected: "\u0645\u0631\u0641\u0648\u0636",
    },
    payment: {
      pending: "\u0627\u0644\u062f\u0641\u0639 \u0645\u0639\u0644\u0642",
      paid: "\u0645\u062f\u0641\u0648\u0639",
      pay: "\u0627\u062f\u0641\u0639 \u0627\u0644\u0622\u0646",
    },
    approve: "\u0645\u0648\u0627\u0641\u0642\u0629",
    reject: "\u0631\u0641\u0636",
  },
  review: {
    title: "\u0627\u0643\u062a\u0628 \u062a\u0642\u064a\u064a\u0645\u0627\u064b",
    description: "\u0634\u0627\u0631\u0643 \u062a\u062c\u0631\u0628\u062a\u0643 \u0645\u0639",
    ratingLabel: "\u0643\u064a\u0641 \u062a\u0642\u064a\u0651\u0645 \u062a\u062c\u0631\u0628\u062a\u0643\u061f",
    rating1: "\u0633\u064a\u0621",
    rating2: "\u0645\u0642\u0628\u0648\u0644",
    rating3: "\u062c\u064a\u062f",
    rating4: "\u062c\u064a\u062f \u062c\u062f\u0627\u064b",
    rating5: "\u0645\u0645\u062a\u0627\u0632",
    commentLabel: "\u062a\u0642\u064a\u064a\u0645\u0643",
    optional: "\u0627\u062e\u062a\u064a\u0627\u0631\u064a",
    commentPlaceholder: "\u0623\u062e\u0628\u0631 \u0627\u0644\u0622\u062e\u0631\u064a\u0646 \u0639\u0646 \u062a\u062c\u0631\u0628\u062a\u0643...",
    for: "\u062a\u0642\u064a\u064a\u0645 \u0644\u0640",
    submit: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062a\u0642\u064a\u064a\u0645",
    success: "\u062a\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062a\u0642\u064a\u064a\u0645 \u0628\u0646\u062c\u0627\u062d!",
    error: "\u0641\u0634\u0644 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062a\u0642\u064a\u064a\u0645",
    selectRating: "\u064a\u0631\u062c\u0649 \u0627\u062e\u062a\u064a\u0627\u0631 \u062a\u0642\u064a\u064a\u0645",
    noReviews: "\u0644\u0627 \u062a\u0648\u062c\u062f \u062a\u0642\u064a\u064a\u0645\u0627\u062a \u0628\u0639\u062f",
    received: "\u0627\u0644\u062a\u0642\u064a\u064a\u0645\u0627\u062a \u0627\u0644\u0645\u0633\u062a\u0644\u0645\u0629",
    averageRating: "\u0645\u062a\u0648\u0633\u0637 \u0627\u0644\u062a\u0642\u064a\u064a\u0645",
    writeReview: "\u0627\u0643\u062a\u0628 \u062a\u0642\u064a\u064a\u0645\u0627\u064b",
    reviewed: "\u062a\u0645 \u0627\u0644\u062a\u0642\u064a\u064a\u0645",
    completedWedding: "\u0627\u0643\u062a\u0645\u0644 \u0647\u0630\u0627 \u0627\u0644\u0632\u0641\u0627\u0641. \u064a\u0645\u0643\u0646\u0643 \u0627\u0644\u0622\u0646 \u0643\u062a\u0627\u0628\u0629 \u062a\u0642\u064a\u064a\u0645.",
  },
  messages: {
    title: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644",
    noMessages: "\u0644\u0627 \u062a\u0648\u062c\u062f \u0631\u0633\u0627\u0626\u0644",
    placeholder: "\u0627\u0643\u062a\u0628 \u0631\u0633\u0627\u0644\u0629...",
    send: "\u0625\u0631\u0633\u0627\u0644",
  },
  admin: {
    title: "\u0644\u0648\u062d\u0629 \u062a\u062d\u0643\u0645 \u0627\u0644\u0625\u062f\u0627\u0631\u0629",
    stats: {
      users: "\u0627\u0644\u0645\u0633\u062a\u062e\u062f\u0645\u0648\u0646",
      hosts: "\u0627\u0644\u0645\u0636\u064a\u0641\u0648\u0646",
      guests: "\u0627\u0644\u0636\u064a\u0648\u0641",
      weddings: "\u062d\u0641\u0644\u0627\u062a \u0627\u0644\u0632\u0641\u0627\u0641",
      activeWeddings: "\u062d\u0641\u0644\u0627\u062a \u0627\u0644\u0632\u0641\u0627\u0641 \u0627\u0644\u0646\u0634\u0637\u0629",
      applications: "\u0627\u0644\u0637\u0644\u0628\u0627\u062a",
      revenue: "\u0625\u062c\u0645\u0627\u0644\u064a \u0627\u0644\u0625\u064a\u0631\u0627\u062f\u0627\u062a",
      platformEarnings: "\u0623\u0631\u0628\u0627\u062d \u0627\u0644\u0645\u0646\u0635\u0629",
    },
    tabs: {
      overview: "\u0646\u0638\u0631\u0629 \u0639\u0627\u0645\u0629",
      users: "\u0627\u0644\u0645\u0633\u062a\u062e\u062f\u0645\u0648\u0646",
      weddings: "\u062d\u0641\u0644\u0627\u062a \u0627\u0644\u0632\u0641\u0627\u0641",
      transactions: "\u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062a",
    },
    actions: {
      ban: "\u062d\u0638\u0631",
      unban: "\u0631\u0641\u0639 \u0627\u0644\u062d\u0638\u0631",
      feature: "\u062a\u0645\u064a\u064a\u0632",
      unfeature: "\u0625\u0644\u063a\u0627\u0621 \u0627\u0644\u062a\u0645\u064a\u064a\u0632",
    },
  },
  common: {
    loading: "\u062c\u0627\u0631\u064a \u0627\u0644\u062a\u062d\u0645\u064a\u0644...",
    error: "\u062d\u062f\u062b \u062e\u0637\u0623",
    success: "\u0646\u062c\u0627\u062d",
    save: "\u062d\u0641\u0638",
    cancel: "\u0625\u0644\u063a\u0627\u0621",
    delete: "\u062d\u0630\u0641",
    edit: "\u062a\u0639\u062f\u064a\u0644",
    back: "\u0631\u062c\u0648\u0639",
    next: "\u0627\u0644\u062a\u0627\u0644\u064a",
    language: "\u0627\u0644\u0644\u063a\u0629",
    currency: "\u0627\u0644\u0639\u0645\u0644\u0629",
  },
  footer: {
    about: "\u062d\u0648\u0644",
    privacy: "\u0627\u0644\u062e\u0635\u0648\u0635\u064a\u0629",
    terms: "\u0627\u0644\u0634\u0631\u0648\u0637",
    contact: "\u0627\u062a\u0635\u0644 \u0628\u0646\u0627",
    description: "\u0627\u0644\u0645\u0646\u0635\u0629 \u0627\u0644\u0639\u0627\u0644\u0645\u064a\u0629 \u0644\u062a\u062c\u0627\u0631\u0628 \u0627\u0644\u0632\u0641\u0627\u0641 \u0627\u0644\u0644\u0627 \u062a\u064f\u0646\u0633\u0649.",
    copyright: "\u00a9 2024 WEDVAYA. \u062c\u0645\u064a\u0639 \u0627\u0644\u062d\u0642\u0648\u0642 \u0645\u062d\u0641\u0648\u0638\u0629.",
  },
  notifications: {
    title: "\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062a",
    empty: "\u0644\u0627 \u062a\u0648\u062c\u062f \u0625\u0634\u0639\u0627\u0631\u0627\u062a \u0628\u0639\u062f",
    markAllRead: "\u062a\u0639\u064a\u064a\u0646 \u0627\u0644\u0643\u0644 \u0643\u0645\u0642\u0631\u0648\u0621",
  },
  chat: {
    conversations: "\u0627\u0644\u0645\u062d\u0627\u062f\u062b\u0627\u062a",
    search: "\u0627\u0644\u0628\u062d\u062b \u0641\u064a \u0627\u0644\u0645\u062d\u0627\u062f\u062b\u0627\u062a...",
    noConversations: "\u0644\u0627 \u062a\u0648\u062c\u062f \u0645\u062d\u0627\u062f\u062b\u0627\u062a \u0628\u0639\u062f",
    selectConversation: "\u0627\u062e\u062a\u0631 \u0645\u062d\u0627\u062f\u062b\u0629",
    selectConversationDesc: "\u0627\u062e\u062a\u0631 \u0645\u062d\u0627\u062f\u062b\u0629 \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0644\u0628\u062f\u0621 \u0627\u0644\u062f\u0631\u062f\u0634\u0629",
    online: "\u0645\u062a\u0635\u0644",
    offline: "\u063a\u064a\u0631 \u0645\u062a\u0635\u0644",
    connecting: "\u062c\u0627\u0631\u064a \u0627\u0644\u0627\u062a\u0635\u0627\u0644...",
    noMessages: "\u0644\u0627 \u062a\u0648\u062c\u062f \u0631\u0633\u0627\u0626\u0644 \u0628\u0639\u062f",
    startConversation: "\u0627\u0628\u062f\u0623 \u0627\u0644\u0645\u062d\u0627\u062f\u062b\u0629!",
    placeholder: "\u0627\u0643\u062a\u0628 \u0631\u0633\u0627\u0644\u0629...",
    you: "\u0623\u0646\u062a",
  },
  cookies: {
    title: "\u0646\u0633\u062a\u062e\u062f\u0645 \u0645\u0644\u0641\u0627\u062a \u062a\u0639\u0631\u064a\u0641 \u0627\u0644\u0627\u0631\u062a\u0628\u0627\u0637",
    description: "\u0646\u0633\u062a\u062e\u062f\u0645 \u0645\u0644\u0641\u0627\u062a \u062a\u0639\u0631\u064a\u0641 \u0627\u0644\u0627\u0631\u062a\u0628\u0627\u0637 \u0644\u062a\u062d\u0633\u064a\u0646 \u062a\u062c\u0631\u0628\u062a\u0643 \u0648\u062a\u062d\u0644\u064a\u0644 \u062d\u0631\u0643\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0648\u0644\u0623\u063a\u0631\u0627\u0636 \u0627\u0644\u062a\u0633\u0648\u064a\u0642.",
    acceptAll: "\u0642\u0628\u0648\u0644 \u0627\u0644\u0643\u0644",
    rejectAll: "\u0631\u0641\u0636 \u0627\u0644\u0643\u0644",
    customize: "\u062a\u062e\u0635\u064a\u0635",
    settingsTitle: "\u0625\u0639\u062f\u0627\u062f\u0627\u062a \u0645\u0644\u0641\u0627\u062a \u062a\u0639\u0631\u064a\u0641 \u0627\u0644\u0627\u0631\u062a\u0628\u0627\u0637",
    functional: "\u0645\u0644\u0641\u0627\u062a \u062a\u0639\u0631\u064a\u0641 \u0627\u0644\u0627\u0631\u062a\u0628\u0627\u0637 \u0627\u0644\u0648\u0638\u064a\u0641\u064a\u0629",
    functionalDesc: "\u0636\u0631\u0648\u0631\u064a\u0629 \u0644\u0639\u0645\u0644 \u0627\u0644\u0645\u0648\u0642\u0639 \u0628\u0634\u0643\u0644 \u0635\u062d\u064a\u062d.",
    analytics: "\u0645\u0644\u0641\u0627\u062a \u062a\u0639\u0631\u064a\u0641 \u0627\u0644\u0627\u0631\u062a\u0628\u0627\u0637 \u0627\u0644\u062a\u062d\u0644\u064a\u0644\u064a\u0629",
    analyticsDesc: "\u062a\u0633\u0627\u0639\u062f\u0646\u0627 \u0639\u0644\u0649 \u0641\u0647\u0645 \u0643\u064a\u0641\u064a\u0629 \u062a\u0641\u0627\u0639\u0644 \u0627\u0644\u0632\u0648\u0627\u0631 \u0645\u0639 \u0627\u0644\u0645\u0648\u0642\u0639.",
    marketing: "\u0645\u0644\u0641\u0627\u062a \u062a\u0639\u0631\u064a\u0641 \u0627\u0644\u0627\u0631\u062a\u0628\u0627\u0637 \u0627\u0644\u062a\u0633\u0648\u064a\u0642\u064a\u0629",
    marketingDesc: "\u062a\u064f\u0633\u062a\u062e\u062f\u0645 \u0644\u0639\u0631\u0636 \u0625\u0639\u0644\u0627\u0646\u0627\u062a \u0645\u062e\u0635\u0635\u0629.",
    saveSettings: "\u062d\u0641\u0638 \u0627\u0644\u0625\u0639\u062f\u0627\u062f\u0627\u062a",
  },
};

export default ar;
